import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
import { FirebaseService } from 'src/app/services/firebase.service';
import { GlobalService } from 'src/app/services/global.service';
import { ChooseClientComponent } from 'src/app/shared/choose-client/choose-client.component';

@Component({
    selector: 'app-copy-account-data',
    templateUrl: './copy-account-data.component.html',
    styleUrls: ['./copy-account-data.component.scss'],
    standalone: false,
})
export class CopyAccountDataComponent {
    fromAccountId = '';
    fromAccountName = '';
    toAccountId = '';
    toAccountName = '';

    constructor(
        public glo: GlobalService,
        public firebaseService: FirebaseService,
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<CopyAccountDataComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: { leadId: string; email: string; name: string; clientType: string; clientSize: number },
    ) {}

    ngOnInit() {}

    async copyAccountData() {
        try {
            const res = await this.firebaseService.requestCopyAccountData(this.fromAccountId, this.toAccountId);
            console.log(res);
            this.glo.endLoading();
            if (res && res.result === 'ok') {
                this.glo.alert('Account erfolgreich kopiert!');
                this.dialogRef.close();
            }

            if (res && res.result === 'error') {
                throw new Error('error');
            }
        } catch (e) {
            console.log(e);
            this.glo.endLoading();
            this.glo.alert('Unbekannter Fehler!');
        }
    }

    selectToKunde() {
        const cfg = new MatDialogConfig();
        cfg.width = '600px';
        const dialogRef = this.dialog.open(ChooseClientComponent, cfg);
        dialogRef.afterClosed().subscribe((choosen) => {
            if (choosen && choosen.client) {
                this.toAccountId = choosen.client.clientId;
                this.toAccountName = choosen.client.name;
            }
            // console.log('The dialog was closed');
        });
    }

    clearFromKunde() {
        this.toAccountId = '';
        this.toAccountName = '';
    }

    selectFromKunde() {
        const cfg = new MatDialogConfig();
        cfg.width = '600px';
        const dialogRef = this.dialog.open(ChooseClientComponent, cfg);
        dialogRef.afterClosed().subscribe((choosen) => {
            if (choosen && choosen.client) {
                this.fromAccountId = choosen.client.clientId;
                this.fromAccountName = choosen.client.name;
            }
            // console.log('The dialog was closed');
        });
    }

    clearToKunde() {
        this.toAccountId = '';
        this.toAccountName = '';
    }
}
